// extracted by mini-css-extract-plugin
export default {"inputImg_1":"BlogPage_inputImg_1__xSA8b","inputImg_2":"BlogPage_inputImg_2__ckkXw","inputImg_3":"BlogPage_inputImg_3__Q24Uq","inputImg_4":"BlogPage_inputImg_4__D92MZ"};